/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  APPOINTMENT_FETCH_REQUEST,
  APPOINTMENT_FETCH_REQUEST_SUCCESS,
  APPOINTMENT_FETCH_REQUEST_FAILURE,
  SINGLE_APPOINTMENT_ADD_REQUEST,
  SINGLE_APPOINTMENT_ADD_REQUEST_SUCCESS,
  SINGLE_APPOINTMENT_ADD_REQUEST_FAILURE,
  SINGLE_APPOINTMENT_FETCH_REQUEST,
  SINGLE_APPOINTMENT_FETCH_REQUEST_SUCCESS,
  SINGLE_APPOINTMENT_FETCH_REQUEST_FAILURE,
  SINGLE_APPOINTMENT_UPDATE_REQUEST,
  SINGLE_APPOINTMENT_UPDATE_REQUEST_SUCCESS,
  SINGLE_APPOINTMENT_UPDATE_REQUEST_FAILURE,
  APPOINTMENT_CLEAN_REQUEST,
  APPOINTMENT_SLOT_FETCH_REQUEST,
  APPOINTMENT_SLOT_FETCH_REQUEST_SUCCESS,
  APPOINTMENT_SLOT_FETCH_REQUEST_FAILURE,
  APPOINTMENT_SLOT_CLEAN_REQUEST,
  SINGLE_APPOINTMENT_CLEAN_REQUEST,
  NEW_APPOINTMENT_FETCH_REQUEST_FAILURE,
  NEW_APPOINTMENT_FETCH_REQUEST,
  NEW_APPOINTMENT_FETCH_REQUEST_SUCCESS,
  APPOINTMENT_VALIDATION_CHECK_REQUEST,
  APPOINTMENT_VALIDATION_CHECK_REQUEST_SUCCESS,
  APPOINTMENT_VALIDATION_CHECK_REQUEST_FAILURE,
  APPOINTMENT_VALIDATION_CHECK_CLEAN_REQUEST,
  APPOINTMENT_ERRORS_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  slotPayload: [],
  slotLoading: false,
  slotErrors: {},
  nextAppointmentPayload: [],
  nextAppointmentLoading: false,
  nextAppointmentErrors: {},
  validationPayload: [],
  validationLoading: false,
  validationErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appointmentReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APPOINTMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SINGLE_APPOINTMENT_ADD_REQUEST:
    case SINGLE_APPOINTMENT_FETCH_REQUEST:
    case SINGLE_APPOINTMENT_UPDATE_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case APPOINTMENT_SLOT_FETCH_REQUEST:
      return Object.assign({}, state, {
        slotLoading: true,
      });

    case APPOINTMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case SINGLE_APPOINTMENT_ADD_REQUEST_SUCCESS:
    case SINGLE_APPOINTMENT_FETCH_REQUEST_SUCCESS:
    case SINGLE_APPOINTMENT_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case APPOINTMENT_SLOT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        slotLoading: false,
        slotPayload: action.data,
        slotErrors: {},
      });

    case APPOINTMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_APPOINTMENT_ADD_REQUEST_FAILURE:
    case SINGLE_APPOINTMENT_FETCH_REQUEST_FAILURE:
    case SINGLE_APPOINTMENT_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });
    case APPOINTMENT_SLOT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        slotLoading: false,
        slotErrors: action.error,
      });

    case APPOINTMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case SINGLE_APPOINTMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        singleErrors: {},
        singleLoading: false,
      });

    case APPOINTMENT_SLOT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        slotPayload: [],
        slotLoading: false,
      });

    case APPOINTMENT_ERRORS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleErrors: {},
        slotErrors: {},
      });

    case NEW_APPOINTMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        nextAppointmentLoading: true,
      });

    case NEW_APPOINTMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        nextAppointmentLoading: false,
        nextAppointmentPayload: action.data,
        nextAppointmentErrors: {},
      });

    case NEW_APPOINTMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        nextAppointmentLoading: false,
        nextAppointmentErrors: action.error,
      });

    case APPOINTMENT_VALIDATION_CHECK_REQUEST:
      return Object.assign({}, state, {
        validationLoading: true,
      });

    case APPOINTMENT_VALIDATION_CHECK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        validationLoading: false,
        validationPayload: action.data,
        validationErrors: {},
      });

    case APPOINTMENT_VALIDATION_CHECK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        validationLoading: false,
        validationErrors: action.error,
      });

    case APPOINTMENT_VALIDATION_CHECK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        validationPayload: [],
        validationLoading: false,
        validationErrors: {},
      });

    default:
      return state;
  }
};

export default appointmentReducer;
